export default "__VITE_ASSET__BouuKE1t__"